import * as React from "react";
import type { SVGProps } from "react";
const SvgIconPetsAllowed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 23 20"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.12.02c-1.2.09-2.35.75-3.01 1.75-.09.12-.62 1.03-1.18 2.02L9.9 5.59l-2.56-.01c-2.75-.01-2.63 0-3-.14-.3-.1-.51-.24-1.77-1.18-.7-.54-1.34-.99-1.4-1.01-.48-.2-1.05.1-1.15.62C0 3.97 0 5.7 0 10.39c.01 6.07.01 6.4.05 6.57q.29 1.2 1.25 1.8c.91.6 2.11.62 3.03.05.63-.4 1.1-1.02 1.29-1.76.05-.19.05-.26.06-1.4v-1.19h4.66v.97c0 .54.01 1.08.03 1.22.12 1.26 1.03 2.27 2.26 2.52.3.06.77.07 1.08.01 1-.18 1.86-.93 2.19-1.9.14-.45.14-.33.15-3.29v-2.71l1.4-.02c1.47 0 1.5-.01 1.95-.13 1.39-.36 2.47-1.43 2.86-2.82.1-.4.13-.6.15-1.3.01-.77 0-.84-.16-1.07-.17-.24-.12-.22-2.46-1l-2.14-.72-.01-1.78-.02-1.79-.07-.16q-.16-.31-.47-.43C16.96 0 16.91 0 16.16 0c-.44 0-.9 0-1.04.02m-.09 1.74q-.47.08-.9.37c-.2.13-.51.45-.64.65l-1.16 2.01-1.06 1.86.03.2c.17 1.24 1.05 2.25 2.25 2.58.4.11.46.12 2.92.1h2.33l.18-.05c.4-.13.71-.3 1-.6q.47-.44.64-1.06c.04-.14.05-.25.05-.48v-.3l-2.14-.71c-1.58-.53-2.16-.74-2.24-.8-.13-.08-.26-.25-.32-.41-.05-.12-.05-.23-.06-1.76V1.72h-.34c-.2 0-.43.02-.54.04m-13.3 9.47v5.46l.1.18c.14.29.42.53.72.6.48.13.96-.06 1.24-.47.18-.28.18-.2.19-2l.01-1.63.07-.13q.12-.23.34-.38c.2-.13.08-.13 3.69-.12h3.32l.13.07q.41.2.5.63.03.17.03 1.62c0 1.63 0 1.64.15 1.9.38.63 1.25.74 1.77.22.15-.15.27-.36.3-.55.03-.1.03-.9.03-2.74v-2.61l-.32-.03q-1.82-.16-3.07-1.45-.6-.62-.94-1.36c-.12-.27-.28-.73-.33-.97l-.03-.17-2.52-.01c-2.25-.02-2.54-.02-2.72-.06-.62-.12-1.1-.33-1.59-.66l-1.05-.78c-.02-.02-.02 1.05-.02 5.44"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconPetsAllowed;
